'use client'

import { Doughnut } from 'react-chartjs-2'
import type { ChartData, ChartOptions } from 'chart.js'
import { formatValue } from '@/helpers'
import '../shared/charts/chartSetup'
import styles from '../shared/charts/charts.module.css'

interface DoughnutChartProps {
  data: ChartData<'doughnut'>
  options: ChartOptions<'doughnut'>
}

export function DoughnutChart({ data, options }: DoughnutChartProps) {
  const enhancedOptions: ChartOptions<'doughnut'> = {
    ...options,
    responsive: true,
    maintainAspectRatio: false,
    animation: true,
    transitions: {
      active: { animation: { duration: 400 } }
    },
    plugins: {
      ...options.plugins,
      tooltip: {
        enabled: true,
        ...options.plugins?.tooltip,
        callbacks: {
          ...options.plugins?.tooltip?.callbacks,
          label: (context) => {
            const label = context.label || '';
            const value = context.raw as number;
            return `${label}: ${formatValue(value, true, 1)}`;
          }
        }
      }
    }
  }

  return (
    <div className={styles.chartContainer} style={{ height: '250px' }}>
      <div className={styles.chartWrapper}>
        <Doughnut data={data} options={enhancedOptions} />
      </div>
    </div>
  )
}